/* globals objectFitPolyfill */
import 'objectFitPolyfill';
import BaseComponent from './baseComponent';

/**
 * Component that takes care of autoplaying custom (self-hosted)
 * videos. We could not name this just `Video` since there already is a generic
 * video component that handles video from common sharing platforms.
 */
export default class LocalVideo extends BaseComponent {
  /**
     * Public constructor
     *
     * @param options
     */
  constructor(options) {
    super(options);
    this.hiddenClass = options.hiddenClass || '-hidden';
    return this;
  }

  /**
     * Initialize function
     */
  init() {
    const $video = this.$item;
    const startVideo = () => {
      $video.removeClass(this.hiddenClass);
      objectFitPolyfill($video.get(0));
      $video.get(0).play();
    };
    if (LocalVideo.isIE10or11()) {
      // Only play video after it can be played through fully to prevent
      // black flickering in Internet Explorer.
      $video.on('canplaythrough', startVideo);
    } else {
      startVideo();
    }
  }

  /**
     * Redraw video on resize for IE11. POR-1189.
     * Zoom Window = Resize event.
     */
  updateOnResize() {
    objectFitPolyfill(this.$item.get(0));
  }

  /**
     * Checks if agent is IE10 or IE11.
     * @see https://codepen.io/gapcode/pen/vEJNZN
     * @returns {boolean}
     */
  static isIE10or11() {
    const ua = window.navigator.userAgent;
    return (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0);
  }
}
